import { TableCell, TableHead, TableRow } from '@mui/material';

export const CustomTableHeader = () => {
    return (
        <TableHead>
            <TableRow>
                <TableCell>Name</TableCell>
                <TableCell align='right'>Code</TableCell>
                <TableCell></TableCell>
            </TableRow>
        </TableHead>
    );
};
